export default __webpack_public_path__ + "static/media/no-data-img.df12f47d.svg";